import jwtDecode from "jwt-decode";

export default class Identity {

    constructor(name, authtoken) {
        this.name = name;
        this.isAdmin = jwtDecode(authtoken).role === 'Admin'
    }
}